<template>
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5564 8.54517H19.4523L15.3104 13.279L20.183 19.7208H16.3678L13.3796 15.8139L9.96045 19.7208H8.06348L12.4936 14.6574L7.81934 8.54517H11.7314L14.4324 12.1162L17.5564 8.54517ZM16.891 18.586H17.9416L11.1605 9.62032H10.0332L16.891 18.586Z" fill="currentColor" />
  </svg>
</template>
